module.exports = __webpack_public_path__ + "static/media/MemoryBytes.6d80b116.png";